// require axios for xhr
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';



/**
 * create axios
 * you can insert global parameters here. e.g. withCredentials: true
 */
const client = axios.create({
    withCredentials: true
});

/**
 * xhrRequest
 *
 * @param options
 * @returns {Promise.<T>}
 */
window.xhrRequest = function(options) {

    // return response on success
    const onSuccess = function(response) {
        return response;
    };

    // return errors on failure
    const onError = function(error) {
        console.error('>>> Request Failed:', error.config);
        if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data.content);
            console.error('Headers:', error.response.headers);
        } else {
            console.error('Error Message:', error.message);
        }
        return Promise.reject(error.response || error.message);
    };

    // return promise
    return client(options).then(onSuccess).catch(onError);
};

